exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n    color:#000;\n    /* background-color: #FC4B0A; */\n    font-family: 'Special Elite', cursive;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n.footer a {\n    color: #000;\n}\nul {\n    list-style: none;\n}\n.container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    max-width: 100%;\n    overflow-x: hidden;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\nimg {\n    max-width: 100%;\n    width: 100%;\n}\nh1, h2, h3, h4 {\n    max-width: 100%;\n\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main